import { COURSEWAREITEM } from './constants';

export const getCoursewareItem = (state, id) => (
  state.getIn([COURSEWAREITEM, id])
);

export const getInCoursewareItem = (state, id, keyPath) => (
  state.getIn([COURSEWAREITEM, id, ...keyPath])
);
